var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[_vm._v(" Group "),_c('em',[_vm._v("devices")]),_vm._v(" to conveniently manage user access and deploy "+_vm._s(_vm.componentData)+" en masse. ")])
}
var staticRenderFns = []

export { render, staticRenderFns }